
var event = {
	type:'',// 支持on还是degelete
	ele:null,// 根元素
	on:function(event, selector, fn){
		this.ele.off(event, selector, fn).on(event, selector, fn);
	},

	delegate:function(event, selector, fn){
		this.ele.undelegate(selector, event, fn).delegate(selector, event, fn);
	},

	click : function(event, selector, fn){
		var _this = this;
		this.ele[0].onclick = function(e){
			var evt =  window.event || e;
			var evtTarget = evt.target || evt.srcElement;
			_this.searchTarget( evtTarget, this, selector, fn);
		}
	},

	searchTarget : function(elem, that, selector, fn){
		var elem = elem,i=0;
		if($(elem).find(selector).length>0){
			return false;
		}
		while(i<20){
			if(that==elem){
				if(selector==''){
					fn.call(elem)
				}
				break;
			}

			// console.log(this.booDom(elem,selector))

			if(this.booDom(elem,selector)){
				fn.call(elem)
				break;
			}


			elem = elem.parentElement;
			i++;
		}
	},

	booDom:function(elem,selector){

		var selector = selector.replace(/(^\s*)|(\s*$)/g, "");
		switch (selector[0]){
			case ".":
				return elem.className.indexOf(selector.substr(1))>-1;
				break;
			case "#":
				return elem.id.indexOf(selector.substr(1))>-1;
				break;
			default:
			   return elem.tagName == selector.substr(1).toUpperCase();
		}
	},

	event: function(){
		var _this = this;
		return function(ele){
			_this.ele = ele;
			_this.type||_this.selected(ele);//判断只支持一次调用
			return _this;
		}
	},

	$on:function(event, selector, fn){
		this[this.type](event, selector, fn);
		return this;
	},
	// 判断是否支持on
	selected : function(ele){
		if(ele.on){
			this.type = 'on'
		}else if(ele.delegate){
			this.type = 'delegate'
		}else{
			this.type = 'click'
		}
	}
}

function addClick(){
	
}


export default event.event();